import DomainCommon from "./common";

const TemperatureService = {

    getUnReports: async ({date, department}) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getApiUrl()}/temperature/getUnReports`,
                params: {date, department},
                resolve, reject
            });
        });
    },

    reportedTemperatureWithDept: async ({date, department}) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getApiUrl()}/temperature/reportedTemperatureWithDept`,
                params: {date, department},
                resolve, reject
            });
        });
    },

    getTotalLength: async ({start, end, department}) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getApiUrl()}/temperature/totalLength`,
                params: {start, end, depts: department},
                resolve, reject
            });
        });
    },

    statistic: async ({department}) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getApiUrl()}/temperature/stat`,
                params: {department},
                resolve, reject
            });
        });
    },

    statWithLimit: async ({department, limit, offset, order, startDate, endDate}) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getApiUrl()}/temperature/statWithLimit`,
                params: {department, limit, offset, order, startDate, endDate},
                resolve, reject
            });
        });
    },

    list: function (department) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getApiUrl()}/temperature`,
                params: {department},
                resolve, reject
            });
        });
    },
    findById: async (id) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getApiUrl()}/temperature/${id}`,
                params: undefined,
                resolve, reject
            });
        });
    },
    add: async (temperature) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getApiUrl()}/temperature`,
                params: undefined,
                jsonBody: temperature,
                resolve, reject
            });
        });
    },
    update: async (id, temperature) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPatch({
                url: `${DomainCommon.getApiUrl()}/temperature/${id}`,
                params: undefined,
                jsonBody: temperature,
                resolve, reject
            });
        });
    },
    delete: async (temperature) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchDelete({
                url: `${DomainCommon.getApiUrl()}/temperature`,
                params: undefined,
                jsonBody: temperature,
                resolve, reject
            });
        });
    },
    deleteById: async (id) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchDelete({
                url: `${DomainCommon.getApiUrl()}/temperature/${id}`,
                params: undefined,
                jsonBody: undefined,
                resolve, reject
            });
        });
    },

};

export default TemperatureService;
